import React from 'react';
import { Link } from 'react-router-dom';
import { NoticeItem, QuickMenuItem } from '../../types';
import styles from './NoticeSection.module.css';

interface NoticeSectionProps {
  noticeItems: NoticeItem[];
  quickMenuItems: QuickMenuItem[];
}

const NoticeSection: React.FC<NoticeSectionProps> = ({ noticeItems, quickMenuItems }) => {
  return (
    <section className={styles.noticeSection}>
      <div className={styles.noticeWrapper}>
        <div className={styles.noticeBox}>
          <div>
            <h3 className={styles.noticeTitle}>
              <span>공지사항</span>
            </h3>
            <button className={styles.expandBtn} aria-label="펼치기">
              +
            </button>
            <ul className={styles.noticeList}>
              {noticeItems.map((item) => (
                <li key={item.id} className={styles.noticeItem}>
                  <Link to={item.href}>
                    <span className={styles.noticeText}>{item.text}</span>
                    <span className={styles.noticeDate}>{item.date}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.quickMenu}>
          <div>
            <ul>
              {quickMenuItems.map((item, index) => (
                <li
                  key={item.id}
                  className={styles.quickItem}
                  style={{ backgroundImage: `url(${item.backgroundImage})` }}
                >
                  <Link to={item.href}>
                    <p
                      className={styles.quickTitle}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <span
                      className={styles.quickDescription}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                    <em className={styles.quickLink}>바로가기</em>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoticeSection;
